import React, { useContext, useState, useReducer } from "react";
import Product from "./Product";
import { ShoppingCart } from "../App";
import { useLocation } from "react-router-dom";
const capitalize = (string) =>
  string.substring(0, 1).toUpperCase() + string.substring(1);

function isValidCategory(category) {
  if (!category || category === undefined || category === null) return false;
  const c = category.toLowerCase();
  if (c === "physical" || c === "digital") return true;
  return false;
}
function getCategoryFromURL(search) {
  const params = new URLSearchParams(search);
  const category = params.get("c");
  console.log(category);
  return !isValidCategory(category) ? "Physical" : capitalize(category);
}

const ProductsCatalog = ({
  physicalProducts = [],
  digitalProducts = [],
  ...props
}) => {
  const { setCart } = useContext(ShoppingCart);
  const { search } = useLocation();

  const [category, changeCategory] = useReducer(
    (category) => (category === "Physical" ? "Digital" : "Physical"),
    getCategoryFromURL(search)
  );
  const getToggleLabel = () => {
    const urlCategory = getCategoryFromURL(search);
    return urlCategory === "Physical" ? "Digital" : "Physical";
  };
  return (
    <section className="section-padding bg-base-100 w-full py-6 pb-12">
      <div className="flex flex-col pb-5 justify-start w-full mb-4 md:flex-row ">
        <h1 className="section-heading mb-3">Products</h1>
        <div className="relative flex-1 flex items-center justify-start md:justify-end float-right bg-base-300 shadow-md rounded-md px-8 py-3 md:bg-base-100 md:p-0 md:shadow-none md:items-center md:pt-6">
          <h2 className="section-desc mb-0 mr-5 mt-0.5">
            {getToggleLabel()} Order:
          </h2>
          <input
            onClick={() => changeCategory()}
            className="toggle ml-auto md:ml-0 "
            type="checkbox"
          />
        </div>
      </div>
      <p className="section-desc">
        Before we can handcraft your artwork, you’ll need to choose a package
        size. Once you make a selection, click on the cart icon to customize
        your text and proceed to checkout!
      </p>
      <p className="section-desc italic">
        The options below may not drawn to scale.{" "}
      </p>
      <div className="dots-bg w-full grid grid-cols-1 gap-4 md:grid-cols-2 lg:align-items-start lg:justify-items-center lg:grid-cols-3 lg:auto-rows-min lg:grid-flow-row-dense">
        {category === "Digital"
          ? digitalProducts.map((product, i) => (
              <Product
                {...product}
                key={i}
                addToCart={(textToIllustrate) =>
                  setCart((cart) => [
                    ...cart,
                    { ...digitalProducts[i], content: textToIllustrate },
                  ])
                }
              />
            ))
          : physicalProducts.map((product, i) => (
              <Product
                {...product}
                key={i}
                addToCart={(textToIllustrate) =>
                  setCart((cart) => [
                    ...cart,
                    { ...physicalProducts[i], content: textToIllustrate },
                  ])
                }
              />
            ))}
      </div>
    </section>
  );
};

export default ProductsCatalog;
